<template>
  <el-dialog
    title="手动添加评委"
    :visible.sync="dialogVisible"
    width="600px"
    class="dialog"
    :close-on-click-modal="false"
    @beforeClose="closeDialog"
  >
    <!-- 第一步，通过手机号码搜索专家 -->
    <div v-if="currentStep === 1" class="dialog-body">
      <div class="dialog-body-jobTitle">
        请输入你要添加的专家登录手机号码
      </div>
      <div class="dialog-body-content m-t-24">
        <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules">
          <el-form-item prop="expertPhone">
            <el-input
              v-model="searchForm.expertPhone"
              placeholder="请输入登录手机号码"
              size="middle"
              maxlength="11"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="flex row-center m-t-40">
        <el-button class="m-r-10" @click="closeDialog">取消</el-button>
        <el-button
          type="primary"
          @click="switchToSearchResult"
        >下一步</el-button>
      </div>
    </div>

    <!-- 第二步 -->
    <div v-if="currentStep === 2" class="dialog-body">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="createFormRules"
        label-suffix="："
        label-width="160px"
      >
        <el-form-item label="登录账号" prop="expertPhone">
          <span>{{ createForm.expertPhone }}</span>
          <span
            v-if="isMobileExist && !disableEdit"
            class="m-l-16 text-warning"
          >
            <i class="el-icon-warning m-r-6"></i>
            该账号已存在，请补充评委信息
          </span>
        </el-form-item>
        <el-form-item v-if="!isMobileExist" label="登录密码" prop="password">
          <div class="flex">
            <el-input
              v-model="createForm.password"
              placeholder="请输入登录密码（必须包含字母和数字）"
              maxlength="20"
            />
            <el-button
              class="m-l-8"
              type="text"
              @click="generatePassword"
            >生成随机密码</el-button>
          </div>
        </el-form-item>
        <el-form-item label="评委姓名" prop="expertName">
          <div class="p-r-80">
            <el-input
              v-model="createForm.expertName"
              placeholder="请输入真实姓名"
              :disabled="disableNameEdit"
              maxlength="20"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="isExtract" label="身份证号" prop="idCard">
          <div class="p-r-80">
            <el-input
              v-model="createForm.idCard"
              placeholder="请输入身份证号"
              :disabled="disableEdit"
              maxlength="20"
            />
          </div>
        </el-form-item>
        <el-form-item label="所在单位" prop="companyName">
          <div class="p-r-80">
            <el-input
              v-model="createForm.companyName"
              placeholder="请输入单位名称"
              :disabled="disableEdit"
              maxlength="30"
            />
          </div>
        </el-form-item>
        <el-form-item label="职称">
          <div class="p-r-80">
            <el-select
              v-model="createForm.jobTitle"
              :disabled="disableEdit"
              placeholder="请选择"
            >
              <el-option
                v-for="item in jobTitleDict.array"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="是否为招标人评委" prop="isPurchaseExpert">
          <el-radio-group
            v-model="createForm.isPurchaseExpert"
            :disabled="!canSwitchPurchaseExpert"
          >
            <el-radio
              v-for="item in whetherDict.array"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <!-- 第三步 -->
    <div v-if="currentStep === 3" class="dialog-body create-expert-success">
      <i
        v-if="isAddExpertSuccess"
        class="el-icon-success text-success success-icon"
      ></i>
      <i v-else class="el-icon-error text-danger success-icon"></i>
      <div class="m-t-24 success-jobTitle">
        评委：{{ createForm.expertPhone }}
        {{ isAddExpertSuccess ? '添加成功' : '添加失败' }}
      </div>
      <div v-if="!isMobileExist" class="m-t-16 success-tip">
        请记录当前设置的登录密码以免丢失：
        <span class="text-warning">{{ tempPassword }}</span>
      </div>
      <div v-if="!isAddExpertSuccess" class="m-t-32 info-tip">
        请点击下方重新添加按钮重试
      </div>

      <div class="m-t-32">
        <el-button @click="closeDialog">关闭弹窗</el-button>
        <el-button
          v-if="isAddExpertSuccess"
          type="primary"
          @click="backToSearchStep"
        >继续添加</el-button>
        <el-button v-else type="primary" @click="addExpert">重新添加</el-button>
      </div>
    </div>

    <div v-if="currentStep === 2" slot="footer" class="flex row-right">
      <el-button @click="backToSearchStep">返回</el-button>
      <el-button type="primary" @click="createExpert">添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 字典
import { whetherDict } from '@/dictionary/project/common'
import { jobTitleDict } from '@/dictionary/expert'
// 工具
import { generatePassword } from '@/utils/utils'
import { mobileValidate, passwordRegularValid } from '@/utils/form-validate'
// 接口
import {
  getExpertIdentityApi,
  getExpertIdentityInfoApi,
  registerExpertV2Api
} from '@/api/expert'

import { requiredRule } from '@/utils/form-validate'
export default {
  expertName: 'KpbManualReviewerDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 是否能选择是否为招标人评委
    canSwitchPurchaseExpert: {
      type: Boolean,
      default: true
    },

    // 添加评委的钩子函数，因外部添加评委接口不一致，故增加钩子函数执行相关步骤
    onAddExpert: {
      type: Function,
      default: () => Promise.resolve()
    },

    // 是否是抽取单页面
    isExtract: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      whetherDict,
      jobTitleDict,

      // 第一步，通过手机号码搜索专家
      searchForm: {
        expertPhone: ''
      },
      searchFormRules: {
        expertPhone: [
          {
            required: true,
            message: '请输入登录手机号码',
            trigger: 'blur'
          },
          {
            pattern: mobileValidate().pattern,
            message: '请输入正确的11位手机号码',
            trigger: ['blur']
          }
        ]
      },
      // 第二步，如果专家不存在的情况下，直接生成专家账号
      createForm: {
        // 专家id
        expertId: '',
        // 登录账号
        expertPhone: '',
        // 登录密码
        password: '',
        // 评委姓名
        expertName: '',
        // 所在单位
        companyName: '',
        // 职称
        jobTitle: '',
        // 是否为招标人评委
        isPurchaseExpert: undefined,
        idCard: '' // 身份证
      },
      createFormRules: {
        expertPhone: requiredRule('请输入登录手机号码'),
        password: [requiredRule('请输入登录密码'), passwordRegularValid],
        expertName: requiredRule('请输入评委姓名'),
        isPurchaseExpert: requiredRule('请选择是否为招标人评委'),
        idCard: [
          requiredRule('请输入法人身份证号'),
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '身份证号格式错误',
            trigger: 'blur'
          }
        ],
        companyName: this.isExtract ? requiredRule('请输入所在单位') : {}
      },

      // 当前的步骤
      currentStep: 1,

      // 判断账号是否存在
      isMobileExist: false,
      // 非抽取页面：专家存在,不能修改；抽取页面：专家认证，不能修改
      disableEdit: false,
      // 名称是否能修改。专家存在不能修改
      disableNameEdit: false,

      // 临时密码
      tempPassword: '',

      // 是否成功添加专家为评委
      isAddExpertSuccess: undefined
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.dialogVisible = false
      this.currentStep = 1
      this.resetSearchForm()
    },

    /**
     * 切换到搜索结果页面
     */
    switchToSearchResult() {
      this.$refs.searchForm.validate(valid => {
        if (!valid) return

        // 查询是否拥有专家身份
        const params = { mobilePhone: this.searchForm.expertPhone }
        getExpertIdentityApi(params)
          .then(res => {
            const data = res.data || {}
            // 如果返回数据中，用户id和专家id都有值，则表明当前搜索的手机号码已注册专家
            this.isMobileExist = Boolean(data.userId)
            if (!this.isExtract) {
              this.disableEdit = Boolean(data.expertId)
            } else {
              this.disableEdit = false
            }
            this.disableNameEdit = Boolean(data.expertId)
            this.currentStep = 2
            this.createForm.expertPhone = this.searchForm.expertPhone
            this.createForm.expertId = data.expertId
            if (data.expertId) this.getExpertIdentityInfo()
          })
          .catch(err => {
            console.error('查询是否拥有专家身份失败', err)
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 查询专家身份信息
     */
    getExpertIdentityInfo() {
      const params = { mobilePhone: this.searchForm.expertPhone }
      getExpertIdentityInfoApi(params)
        .then(res => {
          const data = res.data || {}
          Object.assign(this.createForm, data)
          if (this.isExtract) {
            this.disableEdit = Boolean(data.certificationMark)
          }
          // 如果专家职称返回0，则表明专家职称为空
          if (this.createForm.jobTitle === 0) this.createForm.jobTitle = ''
        })
        .catch(err => {
          console.error('查询专家身份信息失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 返回到搜索步骤
     */
    backToSearchStep() {
      this.resetCreateForm()
      this.currentStep = 1
      this.resetSearchForm()
    },

    /**
     * 点击生成随机密码
     */
    generatePassword() {
      this.createForm.password = generatePassword()
    },

    /**
     * 注册专家
     */
    createExpert() {
      // 已认证专家直接添加
      if (this.disableEdit) {
        this.addExpert()
        return
      }
      this.$refs.createForm.validate(valid => {
        if (!valid) return
        const postData = {
          expertName: this.createForm.expertName,
          mobile: this.createForm.expertPhone,
          originPassword: this.createForm.password,
          companyName: this.createForm.companyName,
          jobTitle: this.createForm.jobTitle,
          idCard: this.createForm.idCard
        }
        registerExpertV2Api(postData)
          .then(res => {
            // 保存新注册的专家id
            this.createForm.expertId = res.data
            this.addExpert()
            // 注册成功后临时保存一份密码
            this.tempPassword = this.createForm.password
          })
          .catch(err => {
            console.error('注册专家失败', err)
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 添加专家
     */
    addExpert() {
      this.onAddExpert(this.createForm)
        .then(() => {
          this.inFinish(true)
        })
        .catch(err => {
          this.inFinish(false)
          console.error('添加专家失败', err)
        })
    },

    /**
     * 重置搜索表单
     */
    resetSearchForm() {
      if (this.$refs.searchForm) {
        this.$refs.searchForm.clearValidate()
      }
      this.searchForm = {
        expertPhone: ''
      }
    },

    /**
     * 重置新增表单
     */
    resetCreateForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.clearValidate()
      }
      this.createForm = {
        expertPhone: '',
        password: '',
        expertName: '',
        idCard: '',
        companyName: '',
        jobTitle: '',
        isPurchaseExpert: undefined
      }
      this.$emit('onResetCreateForm')
    },

    /**
     * 进入添加结束步骤
     */
    inFinish(result) {
      this.isAddExpertSuccess = result
      this.currentStep = 3
      if (result) {
        // 添加完成专家后，要清空所有表格内容
        this.resetCreateForm()
        this.$emit('addExpertSuccess')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-body-jobTitle {
  font-size: 20px;
  @include text-bold;
  text-align: center;
  color: $text-color;
}

.dialog-body-content {
  padding: 0 112px;
}

// 注册专家成功
.create-expert-success {
  display: flex;
  flex-direction: column;
  align-items: center;

  .success-icon {
    font-size: 56px;
  }

  .success-jobTitle {
    font-size: 20px;
    @include text-bold;
    color: $text-color;
  }

  .success-tip {
    font-size: 16px;
    color: $second-text-color;
  }
}
</style>
